export const formFloatInvData = {
  'documentType': null,
  'legalRepresentativeType': null,
  'document': '',
  'documentFile': '',
  'names': '',
  'lastNames': '',
  'clientType': null,
  'dealerReservation': '',
  'adviserCode': '',
  'certificate': null,
  'certificateFile': '',
  'discapacityPerc': '',
  'exonerationPerc': 0,
  'hasLegalRepresentative': null,
  'legalRepresentativeId': '',
  'legalRepresentativeName': '',
  'location': '',
  'city': '',
  'province': '',
  'country': 'EC',
  'phoneNumber': '',
  'email': '',
  'line': '',
  'orderNumber': '',
  'description': '',
  'katashiki': '',
  'sfx': '',
  'externalColor': '',
  'externalColorId': '',
  'internalColor': '',
  'internalColorId': '',
  'chassis': '',
  'motor': '',
  'yearModel': '',
  'fobValue': '',
  'arrivalDate': '',
  'locationText': '',
  'depositDate': null,
  'floatingState': '',
  'reserveAdvance': '',
  'solNacNumber': '',
  'informBillDate': null,
  'observations': '',
  'businessType': '',
  'contributorCode': '',
  'id': '',
  'estSaleDate': null,
  'estBillDate': null,
};
